import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
	state: {
		profile: '',
		status: '',
	},
	mutations: {
		userRequest: (state) => {
			state.status = 'loading';
		},
		userSuccess: (state, profile) => {
			state.status = 'success';
			Vue.set(state, 'profile', profile);
		},
		userError: (state) => {
			state.status = 'error';
		},
		authLogout: (state) => {
			state.profile = {};
		},
	},
	actions: {
		userRequest ({commit, dispatch}) {
			return new Promise((resolve, reject) => {
				commit('userRequest');

				axios.get(`/admin/users/me`)
				.then(resp => {
					let user = resp.data.response.user;
					commit('userSuccess', user);
					resolve(resp);
				})
				.catch(err => {
					// dispatch('authError', {err: err});
					reject(err);
				});
			});
		}
	}, getters: {
		getProfile: state => state.profile,
		isProfileLoaded: state => !!state.profile.name,
	}
}
